import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-notification-details',
    templateUrl: './notification-details.component.html',
    styleUrls: ['./notification-details.component.scss'],
    standalone: false
})
export class NotificationDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
